import { ReactElement } from 'react'
import styles from './WebMatchcardScreen.module.scss'
import { DesktopBodyLarge, DesktopHeadlineLarge, DesktopTitleMedium } from '../../Typography'
import { MatchcardScreenProps } from './MatchcardScreen'
import { mapTitleToChampionshipString, Title } from '../../components/wrestler/Title'

export const WebMatchcardScreen = ({
  matches,
  announcements,
  eventData,
  onBackClick,
}: MatchcardScreenProps): ReactElement => {
  const announcementsHeader = matches.length === 0 ? 'Ankündigungen' : 'Weitere Ankündigungen'

  return (
    <div className={styles.container}>
      <div className={styles.wideColumn}>
        <div className={styles.column}>
          <DesktopBodyLarge className={styles.pointer} onClick={onBackClick}>
            Zurück zum Startbildschirm
          </DesktopBodyLarge>
          <DesktopHeadlineLarge>{eventData.eventName}</DesktopHeadlineLarge>
        </div>
        <div className={styles.column}>
          <div className={styles.imageContainer}>
            <img
              className={styles.backgroundImage}
              src={eventData.eventHintergrund}
              alt={'Bannerhintergrund zur nächsten Show'}
            />
            <img
              className={styles.logoImage}
              src={eventData.eventLogo}
              alt={'Eventlogo zur nächsten Show'}
            />
          </div>
          <div className={styles.matchcardImageRow}>
            {matches.length > 0 &&
              matches
                .filter((matchcardData) => matchcardData.bildAnkuendigung)
                .map((matchcardData) => (
                  <img
                    key={matchcardData.id}
                    src={matchcardData.bildAnkuendigung}
                    alt={`Matchcard für ${matchcardData.teilnehmer}`}
                  />
                ))}
            {announcements.length > 0 &&
              announcements
                .filter((matchcardData) => matchcardData.bildAnkuendigung)
                .map((matchcardData) => (
                  <img
                    key={matchcardData.id}
                    src={matchcardData.bildAnkuendigung}
                    alt={`Ankündigung für ${matchcardData.wrestlerName}`}
                  />
                ))}
          </div>
        </div>
      </div>
      <div className={styles.wideColumn}>
        <DesktopHeadlineLarge>Event Infos</DesktopHeadlineLarge>
        <div className={styles.column}>
          <DesktopBodyLarge>{eventData.eventHalle}</DesktopBodyLarge>
          {eventData.isOpenSunday && (
            <DesktopBodyLarge>
              Eintritt für (Premium-)Supporter und Kinder unter 16 Jahren frei
            </DesktopBodyLarge>
          )}
          {eventData.isOpenSunday && <DesktopBodyLarge>Tickets für 5€ am Einlass</DesktopBodyLarge>}
          <DesktopBodyLarge>
            Einlass: {eventData.eventEinlass} | Beginn: {eventData.eventBeginn}
          </DesktopBodyLarge>
        </div>
        <div className={styles.column}>
          {matches.length > 0 && (
            <>
              {' '}
              <DesktopTitleMedium>Matches</DesktopTitleMedium>
              {matches.map((matchcardData) => (
                <div key={matchcardData.id} className={styles.tightColumn}>
                  <DesktopBodyLarge>{matchcardData.stipulation}</DesktopBodyLarge>
                  {matchcardData.title !== undefined &&
                    matchcardData.title.filter((title) => title !== Title.NONE).length > 0 && (
                      <DesktopBodyLarge fontWeight={600}>
                        {matchcardData.title.map(mapTitleToChampionshipString).join(' & ')}
                      </DesktopBodyLarge>
                    )}
                  <DesktopBodyLarge>{matchcardData.teilnehmer}</DesktopBodyLarge>
                </div>
              ))}
            </>
          )}
          {announcements.length > 0 && (
            <>
              <DesktopTitleMedium>{announcementsHeader}</DesktopTitleMedium>
              {announcements.map((matchcardData) => (
                <div key={matchcardData.id}>
                  <DesktopBodyLarge>{matchcardData.wrestlerName}</DesktopBodyLarge>
                </div>
              ))}
            </>
          )}
          {matches.length === 0 && announcements.length === 0 && (
            <DesktopBodyLarge>
              Ankündigungen zu{' '}
              {!eventData.eventName || eventData.eventName === ''
                ? 'diesem Event'
                : eventData.eventName}{' '}
              folgen in Kürze…
            </DesktopBodyLarge>
          )}
        </div>
      </div>
    </div>
  )
}
